function formatUrl(url = '') {
  return url.replace(/\/\/+/g, '/').replace(/(http(s)?):\//, '$1://')
}

export default formatUrl
